import * as React from "react";
const SvgFiRrGrinStars = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-grin-stars_svg__a)">
      <path
        fill="#062147"
        d="M12 0A12.013 12.013 0 0 0 0 12c.6 15.9 23.4 15.893 24 0A12.013 12.013 0 0 0 12 0m0 22A10.01 10.01 0 0 1 2 12c.5-13.248 19.5-13.245 20 0a10.01 10.01 0 0 1-10 10m5.842-6.458A6.83 6.83 0 0 1 12 19a6.84 6.84 0 0 1-5.848-3.458A1 1 0 0 1 7.2 14.024c1.538.58 3.158.909 4.8.976a15.4 15.4 0 0 0 4.792-.976 1 1 0 0 1 1.05 1.518M5.736 12.754a.715.715 0 0 1-.27-.822l.519-1.606-1.366-1A.734.734 0 0 1 5.052 8h1.681l.511-1.593a.738.738 0 0 1 1.4 0L9.154 8h1.681a.734.734 0 0 1 .433 1.327l-1.366 1 .519 1.606a.736.736 0 0 1-1.134.818l-1.343-.988-1.344.987a.73.73 0 0 1-.864.004m13.551-3.427-1.366 1 .519 1.606a.736.736 0 0 1-1.134.818l-1.343-.988-1.344.988a.73.73 0 0 1-.864 0 .715.715 0 0 1-.27-.822l.52-1.606-1.367-1A.734.734 0 0 1 13.071 8h1.682l.511-1.593a.737.737 0 0 1 1.4 0L17.173 8h1.681a.734.734 0 0 1 .433 1.327"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-grin-stars_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGrinStars;
